(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-blog-categories]').forEach((categories) => {
      if (categories.dataset.initialized) return;
      categories.dataset.initialized = 'true';
      const tabs = categories.querySelector('[data-blog-tabs]');
      const button = categories.querySelector('[data-blog-scroll]');
      const update = () => {
        const end = tabs.scrollWidth - tabs.clientWidth;
        const hasMore = end > 1 && Math.abs(tabs.scrollLeft) < end - 1;
        categories.toggleAttribute('data-overflow', hasMore);
        button.hidden = !hasMore;
      };
      button.addEventListener('click', () => {
        const direction = getComputedStyle(tabs).direction === 'rtl' ? -1 : 1;
        tabs.scrollBy({ left: direction * tabs.clientWidth * .7, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      tabs.addEventListener('scroll', update, { passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(tabs);
      const active = tabs.querySelector('[aria-current]');
      if (active) tabs.scrollLeft = active.offsetLeft - tabs.offsetLeft;
      document.fonts.ready.then(update);
      update();
      categories.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  };
  if (!window.taipanBlogPageInitialized) {
    window.taipanBlogPageInitialized = true;
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
  initialize(document);
})();
